var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMinSize, ArrayUnique, IsArray, IsUUID } from 'class-validator';
/**
 * Berechnen (TM-9134): the practice bundles one-or-more pending
 * `CancellationFee`s into a single Schadensersatz invoice. A single-fee
 * Berechnen passes a one-element array.
 */
export class ChargeCancellationFeesDto {
    cancellationFeeIds;
}
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ArrayUnique(),
    IsUUID('4', { each: true }),
    __metadata("design:type", Array)
], ChargeCancellationFeesDto.prototype, "cancellationFeeIds", void 0);
//# sourceMappingURL=charge-cancellation-fees.dto.js.map